import { render, staticRenderFns } from "./editorImgDrag.vue?vue&type=template&id=01b07161"
import script from "./editorImgDrag.vue?vue&type=script&lang=js"
export * from "./editorImgDrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b07161')) {
      api.createRecord('01b07161', component.options)
    } else {
      api.reload('01b07161', component.options)
    }
    module.hot.accept("./editorImgDrag.vue?vue&type=template&id=01b07161", function () {
      api.rerender('01b07161', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tinymce/components/editorImgDrag.vue"
export default component.exports